import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { borderRadius } from '@atlaskit/theme/constants';
import { getDimensionsWithDefault } from '../utils/lightCards/getDimensionsWithDefault';
import { getSelectionStyles, SelectionStyle, hideNativeBrowserTextSelectionStyles } from '@atlaskit/editor-shared-styles/selection';

/*
 * Used to display the blue border around a selected card without
 * shrinking the image OR growing the card size
 */
var getSelectedBorderStyle = function getSelectedBorderStyle(_ref) {
  var selected = _ref.selected;
  return "\n    ".concat(selected ? hideNativeBrowserTextSelectionStyles : '', "\n\n    &::after {\n      content: '';\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      top: 0;\n      box-sizing: border-box;\n      pointer-events: none;\n      ").concat(borderRadius, "\n      ").concat(selected ? getSelectionStyles([SelectionStyle.Border]) : '', "\n    }\n  ");
};
export var inlinePlayerClassName = 'media-card-inline-player';
export var inlinePlayerWrapperStyles = function inlinePlayerWrapperStyles(_ref2) {
  var dimensions = _ref2.dimensions,
    selected = _ref2.selected;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: ", ";\n\theight: ", ";\n\toverflow: hidden;\n\tborder-radius: ", "px;\n\tposition: relative;\n\tmax-width: 100%;\n\tmax-height: 100%;\n\n\t", "\n\n\tvideo {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n"])), getDimensionsWithDefault(dimensions).width || '100%', getDimensionsWithDefault(dimensions).height || 'auto', borderRadius(), getSelectedBorderStyle(selected));
};
inlinePlayerWrapperStyles.displayName = 'InlinePlayerWrapper';